import type { IconNode } from '../types';

/**
 * @name pie
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNNyAyQzUuNSA0IDguNSA1IDcgNyIgLz4KICA8cGF0aCBkPSJNMTIgMmMtMS41IDIgMS41IDMgMCA1IiAvPgogIDxwYXRoIGQ9Ik0xNyAyYy0xLjUgMiAxLjUgMyAwIDUiIC8+CiAgPHBhdGggZD0iTTIxIDE2cy0yLTUtOS01LTkgNS05IDVsMS43IDUuMWMuMi41LjcuOSAxLjMuOWgxMmMuNSAwIDEuMS0uNCAxLjMtLjlaIiAvPgogIDxwYXRoIGQ9Ik0yIDE2YzEuNyAwIDEuNiAxIDMuMyAxQzcgMTcgNyAxNiA4LjcgMTZzMS42IDEgMy4zIDFjMS43IDAgMS43LTEgMy4zLTEgMS43IDAgMS42IDEgMy4zIDEgMS43IDAgMS43LTEgMy4zLTEiIC8+CiAgPHBhdGggZD0ibTguNSAxNiAxLjUgNiIgLz4KICA8cGF0aCBkPSJNMTUuNSAxNiAxNCAyMiIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/pie
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const pie: IconNode = [
  ['path', { d: 'M7 2C5.5 4 8.5 5 7 7', key: 'fdblq5' }],
  ['path', { d: 'M12 2c-1.5 2 1.5 3 0 5', key: '1qq0cz' }],
  ['path', { d: 'M17 2c-1.5 2 1.5 3 0 5', key: '1t1jp6' }],
  [
    'path',
    { d: 'M21 16s-2-5-9-5-9 5-9 5l1.7 5.1c.2.5.7.9 1.3.9h12c.5 0 1.1-.4 1.3-.9Z', key: 'bja9aa' },
  ],
  [
    'path',
    {
      d: 'M2 16c1.7 0 1.6 1 3.3 1C7 17 7 16 8.7 16s1.6 1 3.3 1c1.7 0 1.7-1 3.3-1 1.7 0 1.6 1 3.3 1 1.7 0 1.7-1 3.3-1',
      key: '171pq4',
    },
  ],
  ['path', { d: 'm8.5 16 1.5 6', key: 'hjaadr' }],
  ['path', { d: 'M15.5 16 14 22', key: '1dm0sk' }],
];

export default pie;
